<template>
  <div>
    <div class="o-container o-container--full u-pad-top--4 u-mrgn-bottom--4">
      <div class="u-txt--medium u-mrgn-bottom--3">{{ title }}</div>
      <div class="u-txt--base u-line-height--20 u-mrgn-bottom--6">
        <EllipsisText :line-num="7" :message="pageDescription" />
      </div>
      <div class="u-mrgn-bottom--6">
        <div class="u-txt--fair">Tokoh Penting</div>
        <div class="u-mrgn-bottom--3 u-txt--base">
          Dewan Komisaris
          <ul>
            <li v-for="(commisioner, index) in keyPerson.commisioners" :key="index" class="u-mrgn-bottom--0">
              {{ commisioner }}
            </li>
          </ul>
        </div>
        <div class="u-mrgn-bottom--3">
          Dewan Direksi
          <ul>
            <li v-for="(director, index) in keyPerson.directors" :key="index" class="u-mrgn-bottom--0">
              {{ director }}
            </li>
          </ul>
        </div>
      </div>
      <div class="u-mrgn-bottom--2">
        <div class="u-txt--fair">Alamat</div>
        <div class="u-txt--base u-line-height--20">
          <div>{{ address.detail }}</div>
          <div>{{ address.province }}</div>
          <div v-if="address.phone">Phone: {{ address.phone }}</div>
          <div v-if="address.fax">Fax: {{ address.fax }}</div>
        </div>
      </div>
    </div>

    <div><ProductList :investment-manager="imCode" /></div>

    <div><OtherLinkFooter :other-links="otherLinks" /></div>
  </div>
</template>

<script>
import EllipsisText from 'shared/components/Ellipsis/EllipsisText';
import ProductList from 'shared/components/mweb/ProductList';
import OtherLinkFooter from 'shared/components/mweb/OtherLinkFooter';

export default {
  name: 'InvestmentManagerDetailMobile',
  components: {
    OtherLinkFooter,
    ProductList,
    EllipsisText,
  },
  props: {
    otherLinks: {
      type: Array,
      default: () => [],
    },
    pageDescription: {
      type: String,
      default: '',
    },
    imCode: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    keyPerson: {
      type: Object,
      default: () => ({}),
    },
    address: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
